import i18next from "i18next"
import {Updater} from "widgets-for-react"
import {UserData} from "../../subscription/subscriptionState"
import {
  buildValidator,
  isValidatorPassed,
  Validator,
  validatorBuilders,
  ValidatorResult,
  validatorResultBuilders
} from "../../validator/validator"

export type Language = Partial<{ Title: string; Id: number; Code: string }>
export const emptyLanguage: Language = {}

const LanguageValidator = buildValidator<Language>({
  Id: [b => b.ne(-1), validatorBuilders.number("Id", () => i18next.t(`subscriptionValidators:Language`))]
})

export type LanguageState = {
  input: Language
  validator: Validator<Language, Language>,
  validatorResult: ValidatorResult,
  isValid(): boolean
}

export const initialLanguageState = (userData?: UserData): LanguageState => {
  let initialLanguage = emptyLanguage
  if (userData && userData.Language && userData.Language.Id) {
    initialLanguage.Id = userData?.Language?.Id
    initialLanguage.Id = userData?.Language?.Id
  }
  return ({
    input:initialLanguage,
    validator:LanguageValidator.setValueToValidate(initialLanguage,initialLanguage),
    validatorResult:validatorResultBuilders.validating(""),
    isValid:function(this:LanguageState) { return isValidatorPassed(this.validatorResult) }
  })
}

export const languageStateUpdaters = {
  input:(u:Updater<LanguageState["input"]>) : Updater<LanguageState> =>
    s => {
      const newInput = u(s.input)
      return ({...s, input:newInput, validator:s.validator.setValueToValidate(newInput, newInput)})
    },
  validation:(u:Updater<LanguageState["validator"]>) : Updater<LanguageState> =>
    s => {
      const newValidator = u(s.validator)
      return ({...s, validator:newValidator, validatorResult:newValidator.evaluateResult() })
    },  
}
